var map = {
	"./streamer.webp": "o/Dv",
	"./streamerEN.webp": "ULDE",
	"./streamerIN.webp": "Wyb7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yv0p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/streamer.*\.webp$
// module id = yv0p
// module chunks = 0